// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iK1h","colMin":"styles_colMin__2Bn9V"};